module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/header-image-04-d2f0e48aa26da6dcabd9b5144f50e4bb.webp";